import view from '../../view';
import handlers from '../handlers';
import blocks from '../../blocks';
import hdrm from '../../hdrm';
import findFirstFor from '../../constraints/filters/find-first-for';

const before = (store) => (next) => (action) => {
  const { type } = action;
  const state = store.getState();

  switch (type) {
    case view.actionTypes.BLUR_FOCUSED_ELEMENT: {
      const focusedElementId = view.selectors.getFocusedElement(state);
      const liveElement = view.accessors.getLiveElement(focusedElementId);
      handlers.onBeforeBlurFocusedElement(liveElement);

      next(action);
      break;
    }
    case view.actionTypes.SHIFT_ELEMENT: {
      const BEFORE_BEGIN = 'beforebegin';
      const AFTER_END = 'afterend';
      const BEFORE_END = 'beforeend';
      const { referenceMap } = hdrm.instance.driver;
      const { elementId } = action.payload;
      const liveElement = view.accessors.getLiveElement(elementId);
      const previousElementRefId = referenceMap.getPreviousReferenceId(liveElement);
      const nextElementRefId = referenceMap.getNextReferenceId(liveElement);
      const parentElementRefId = referenceMap.getParentReferenceId(liveElement);

      let refElementId;
      let position;

      if (previousElementRefId) {
        refElementId = previousElementRefId;
        position = AFTER_END;
      } else if (nextElementRefId) {
        refElementId = nextElementRefId;
        position = BEFORE_BEGIN;
      } else {
        refElementId = parentElementRefId;
        position = BEFORE_END;
      }

      const previousPositionData = { refElementId, position };

      const extendedAction = {
        ...action,
        payload: {
          ...action.payload,
          previousPositionData,
        },
      };

      next(extendedAction);
      break;
    }

    case view.actionTypes.DELETE_ELEMENT: {
      const { elementId } = action.payload;
      const element = view.accessors.getStaticElement(elementId);
      const blockId = blocks.accessors.getBlockIdByElement(element);
      const variationId = blocks.accessors.getVariationIdByElement(element);
      const constraint = findFirstFor(element);
      const constraintId = constraint && constraint.id;

      handlers.onBeforeBlockDeleted({ blockId, variationId, elementId, constraintId });

      next({
        ...action,
        payload: {
          ...action.payload,
          blockId,
          variationId,
        },
      });
      break;
    }

    default:
      next(action);
  }
};

export default before;
